import { Button } from "@mui/material";

export default function ListButton({href, text}) {
    return (
        <Button
            size="large"
            variant="outlined"
            href={href}
            sx={{
                borderRadius: 3,
                py: 1.4,
                color: "#FFF3E0",
                borderColor: "#FFF3E0",
                transition: "all 0.3s ease",

                "&:hover": {
                    backgroundColor: "#264f62",
                    borderColor: "#264f62",
                    color: "#fff",
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 20px rgba(38,79,98,0.35)",
                },

                "&:active": {
                    transform: "scale(0.97)",
                },

                overflow: "hidden",
                "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    background:
                        "radial-gradient(circle at center, rgba(255,255,255,0.35), transparent 60%)",
                    opacity: 0,
                    transition: "opacity 0.4s ease",
                },
                "&:hover::after": {
                    opacity: 1,
                },
            }}>
            {text}
        </Button>
    );
}